import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countConciliatePaymentPlans'
})
export class CountConciliatePaymentPlansPipe implements PipeTransform {

  transform(paymentPlans: any[], isConciliated: boolean): number {
    return paymentPlans.filter(data => data.isConciliated === isConciliated).length;
  }

}
